import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from '../CTAButton';
import { MOCKUP_IMAGE } from '../../data/content';
export function Hero() {
  return <header className="w-full bg-cream px-4 pb-12 pt-8 sm:pt-12" data-id="element-151" data-mp="7ykyuvfkae2z">
      <div className="mx-auto max-w-3xl text-center" data-id="element-152" data-mp="cu9tckcq54sf">
        <p className="font-display text-lg font-bold tracking-tight text-navy" data-id="element-153" data-mp="hvgz6dvb3twg">
          Dra. <span className="text-brandred" data-id="element-154" data-mp="mu0q6sorbvvo">Karito</span>
        </p>
        <p className="mt-1 text-[10px] font-bold uppercase tracking-[0.25em] text-navy/40" data-id="element-155" data-mp="mtsakt192cgs">
          Ruta Anticoagulación™
        </p>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="mt-6 font-display text-[30px] leading-[1.1] font-black tracking-tight text-navy sm:text-5xl md:text-[56px]" data-id="element-156" data-mp="vmm49vhg1ee6">
          Toma decisiones correctas en anticoagulación en{' '}
          <span className="italic text-brandred" data-id="element-157" data-mp="1ak4qaq2qldhx">menos de 60 segundos</span>
        </motion.h1>

        <p className="mx-auto mt-5 max-w-xl text-[15px] leading-relaxed text-navy/70 sm:text-lg" data-id="element-158" data-mp="9olxq9grhynd">
          Sin volver a dudar entre anticoagular o no, aunque tengas múltiples variables clínicas
          frente a ti.
        </p>

        <motion.img initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.15
      }} src={MOCKUP_IMAGE} alt="Los 6 Tomos Maestros de Ruta Anticoagulación más los 5 bonos exclusivos" className="mx-auto mt-8 w-full max-w-2xl" data-id="element-159" data-mp="3vx3qn70wrvbs" />

        <div id="hero-cta" className="mt-4 flex flex-col items-center" data-id="element-160" data-mp="inphlfnr6i2x">
          <CTAButton data-id="element-161" data-mp="en5l8eb07ihu" />
        </div>

        <p className="mx-auto mt-8 max-w-md text-[13px] font-semibold leading-relaxed text-navy/60" data-id="element-162" data-mp="elufi8y000o3">
          Más de 1.200 médicos ya dejaron de improvisar y ahora toman decisiones con certeza clínica
          real.
        </p>
      </div>
    </header>;
}